"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProductCategoryId = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _request = _interopRequireDefault(require("./request"));

var _logger = _interopRequireDefault(require("../../logger"));

var logAndReturnNull = function logAndReturnNull(message) {
  _logger.default.warn(message, 'productCategory');

  return null;
};

var getProductCategoryId =
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee(mcpSku, onGetAccessToken) {
    var response, familyReferenceId;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _request.default)("https://introduction.products.cimpress.io/v2/families?skuReferenceId=".concat(mcpSku), onGetAccessToken);

          case 2:
            response = _context.sent;
            familyReferenceId = response && response.length === 1 ? response[0].familyReferenceId : logAndReturnNull("unable to retrieve family ref ID for sku [".concat(mcpSku, "]"));
            return _context.abrupt("return", familyReferenceId ? (0, _request.default)("https://introduction.products.cimpress.io/v2/families/".concat(familyReferenceId), onGetAccessToken).then(function (result) {
              return result.categoryId;
            }) : null);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getProductCategoryId(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.getProductCategoryId = getProductCategoryId;